import { memo, useState } from 'react'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { observer } from 'mobx-react'
import useStore from 'stores/utils/hooks/useStore'
import { trackTermsAndConditions } from '../../helpers/trackTermsAndConditions'
import {
  VOUCHER_ACTIVATED_TITLE,
  VOUCHER_TERMS_URL
} from '../../VoucherBanner.constants'
import { VoucherBannerVariant } from '../../VoucherBanner.types'
import {
  BannerContainer,
  MaxWidthWrapper,
  ContentContainer,
  Illustration,
  HeaderRow,
  TitleRow,
  Title,
  BodyText,
  UnderlinedLink
} from './TopActivatedVoucherBanner.styles'
import { VARIANT_COPY } from './TopActivatedVoucherBanner.constants'

interface TopActivatedVoucherBannerProps {
  tenant: VoucherBannerVariant
  amount: number
}

function TopActivatedVoucherBannerComponent({
  tenant,
  amount
}: TopActivatedVoucherBannerProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const {
    traversal: { data }
  } = useStore()
  const { illustration, body } = VARIANT_COPY[tenant]

  return (
    <BannerContainer variant={tenant}>
      <MaxWidthWrapper>
        <Illustration
          src={illustration}
          alt=""
          aria-hidden="true"
          variant={tenant}
          isCollapsed={!isExpanded}
        />
        <ContentContainer>
          <HeaderRow>
            <TitleRow>
              <CheckCircleIcon
                sx={{ color: '#fff', fontSize: 22, flexShrink: 0 }}
              />
              <Title variant="body1" bannerVariant={tenant}>
                {VOUCHER_ACTIVATED_TITLE(amount)}
              </Title>
            </TitleRow>
            <IconButton
              size="small"
              onClick={() => setIsExpanded((prev) => !prev)}
              aria-label={isExpanded ? 'Schließen' : 'Mehr erfahren'}
              sx={{ color: '#fff', ml: 1 }}
            >
              {isExpanded ? (
                <CloseIcon fontSize="small" />
              ) : (
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{
                    color: tenant === 'smava' ? '#C5E8C7' : '#D0DCEA'
                  }}
                />
              )}
            </IconButton>
          </HeaderRow>
          <Collapse in={isExpanded} unmountOnExit>
            <BodyText variant="body2" bannerVariant={tenant}>
              {'Gutschein entsprechend den '}
              <UnderlinedLink
                href={VOUCHER_TERMS_URL[tenant]}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Bedingungen (öffnet in neuem Fenster)"
                onClick={() => trackTermsAndConditions(data)}
              >
                Bedingungen
              </UnderlinedLink>
              {body(amount)}
            </BodyText>
          </Collapse>
        </ContentContainer>
      </MaxWidthWrapper>
    </BannerContainer>
  )
}

export const TopActivatedVoucherBanner = memo(
  observer(TopActivatedVoucherBannerComponent)
)
